import { FormProvider, useForm } from "react-hook-form";

import ModalOutlet from "@/components/modals/router/ModalOutlet";

import { ForgotPasswordForm } from "./types";

const ForgotPasswordWrap = () => {
  const settings = useForm<ForgotPasswordForm>();

  return (
    <div className="max-w-[32.5rem]">
      <FormProvider {...settings}>
        <ModalOutlet />
      </FormProvider>
    </div>
  );
};

export default ForgotPasswordWrap;
